import { Translation } from '@ps/web-shared-components';
import { requiredNumber } from '@ps/web-shared-validators';
import React from 'react';

import InfoPrompt from '../../../../../../../../InfoPrompt/InfoPrompt';
import RMFDropDown from '../../../../../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_According_to_Danish_Gaming_Aut_ELL,
  TXTCLI_Below_N0_per_month,
  TXTCLI_DonXt_know,
  TXTCLI_Intent_to_Play,
  TXTCLI_More,
  TXTCLI_N0_per_month,
  TXTWCL_Please_indicate_your_intended__ELL,
  TXTWCL_Select_amount_1
} from './IntentToPlay.messages.json';
import { fieldWrapper, wrapper } from './IntentToPlay.scss';

const FIELD_TYPE = 'intentToPlay';

enum IntentToPlayValues {
  Unknown = 0,
  Monthly10 = 1,
  Monthly100 = 2,
  Monthly1000 = 3,
  MonthlyMore = 4
}
interface IntentToPlayOptions {
  text: JSX.Element;
  value: number;
}
enum OptionsTextValues {
  Monthly10 = '$10',
  Monthly100 = '$10 - $100',
  Monthly1000 = '$100 - $1000'
}
const OPTIONS: IntentToPlayOptions[] = [
  {
    text: <Translation {...TXTCLI_DonXt_know} />,
    value: IntentToPlayValues.Unknown
  },
  {
    text: (
      <Translation
        {...TXTCLI_Below_N0_per_month}
        values={{
          0: OptionsTextValues.Monthly10
        }}
      />
    ),
    value: IntentToPlayValues.Monthly10
  },
  {
    text: (
      <Translation
        {...TXTCLI_N0_per_month}
        values={{
          0: OptionsTextValues.Monthly100
        }}
      />
    ),
    value: IntentToPlayValues.Monthly100
  },
  {
    text: (
      <Translation
        {...TXTCLI_N0_per_month}
        values={{
          0: OptionsTextValues.Monthly1000
        }}
      />
    ),
    value: IntentToPlayValues.Monthly1000
  },
  {
    text: <Translation {...TXTCLI_More} />,
    value: IntentToPlayValues.MonthlyMore
  }
];

const IntentToPlay: React.FC = () => (
  <div className={fieldWrapper}>
    <RMFDropDown
      id={FIELD_TYPE}
      label={TXTCLI_Intent_to_Play}
      options={OPTIONS}
      validators={[requiredNumber(TXTWCL_Please_indicate_your_intended__ELL)]}
      className={wrapper}
      placeholder={<Translation {...TXTWCL_Select_amount_1} />}
      labelContent={
        <InfoPrompt title={{ translation: TXTCLI_Intent_to_Play }} variant="verification">
          <Translation tagName="p" {...TXTCLI_According_to_Danish_Gaming_Aut_ELL} />
        </InfoPrompt>
      }
    />
  </div>
);

export default IntentToPlay;
